import { gql } from '@apollo/client';

export interface ProductDetails {
  id: number;
  name: string;
  localName: string | null;
  brand: string | null;
  country: string | null;
  countryOfPurchase: string | null;
  physicalState: string | null;
  servingVessel: string | null;
  ingredients: string | null;
  dietaryRestrictions: string | null;
  restrictions: string | null;
  nutritionalInformation: Record<string, unknown> | null;
  prototype: boolean | null;
  public: boolean | null;
  aroma: boolean | null;
  createdAt: string | null;
  producer: { name: string } | null;
  category: { name: string } | null;
  productImages: { nodes: { url: string }[] };
  productReviews: { totalCount: number };
}

export interface ProductDetailsResponse {
  product: ProductDetails | null;
}

/** Everything the product info dialog shows about one product. */
export default gql`
  query ProductDetailsQuery($id: Int!) {
    product: productById(id: $id) {
      id
      name
      localName
      brand
      country
      countryOfPurchase
      physicalState
      servingVessel
      ingredients
      dietaryRestrictions
      restrictions
      nutritionalInformation
      prototype
      public
      aroma
      createdAt
      producer: producerByProducerId {
        name
      }
      category: productCategoryByCategoryId {
        name
      }
      productImages: productImagesByProductId(first: 4) {
        nodes {
          url
        }
      }
      productReviews: productReviewsByProductId {
        totalCount
      }
    }
  }
`;
